import Api from './api';

const PATH = '/llm-event';

const getAll = async () => {
  try {
    const response = await Api.get(`${PATH}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

const getAllEventSystem = async () => {
  try {
    const response = await Api.get(`${PATH}/all-event-system`);
    return response.data;
  } catch (err) {
    throw err;
  }
}


const getAllEventDynamics = async () => {
  try {
    const response = await Api.get(`${PATH}/dynamics`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

const getAllEventDynamicByLLMId = async (llmId) => {
  try {
    const response = await Api.get(`${PATH}/dynamics/${llmId}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

const getAllPaginate = async (page) => {
  try {
    const response = await Api.get(`${PATH}/paginate?page=${page}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

const create = async (input) => { 
  try {
    const response = await Api.post(PATH, input);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const update = async (input) => { 
  try {
    const response = await Api.put(PATH, input);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const deleteById = async (id) => {
  try {
    const response = await Api.delete(`${PATH}/${id}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

export {
  getAll,
  getAllPaginate,
  create,
  update,
  deleteById,
  getAllEventDynamicByLLMId,
  getAllEventDynamics,
  getAllEventSystem
};